import { render } from "./ConfirmRegister.vue?vue&type=template&id=5fbe1706"
import script from "./ConfirmRegister.vue?vue&type=script&lang=ts"
export * from "./ConfirmRegister.vue?vue&type=script&lang=ts"
script.render = render

export default script